import React from 'react';

import { Box, Chip } from '@material-ui/core';

const RopaCountryChips: React.FC<{ countriesSummary?: string }> = ({ countriesSummary }) => {
  const codes = Array.from(
    new Set(
      (countriesSummary ?? '')
        .split(',')
        .map(code => code.trim())
        .filter(Boolean),
    ),
  );
  if (!codes.length) return <>—</>;
  return (
    <Box display='flex' flexWrap='wrap'>
      {codes.map(code => (
        <Box key={code} mb={0.5} mr={0.5}>
          <Chip label={code} size='small' />
        </Box>
      ))}
    </Box>
  );
};

export default RopaCountryChips;
